import './Styles/App.scss'
import FooterStart from './Components/Common/FooterStart'
import Nav from './Components/Common/Nav'
import NavExtra from './Components/Common/NavExtra'
import Imprint from './Pages/Imprint'
import Privacy from './Pages/Privacy'
import Hero from './Pages/Hero'
import Bio from './Pages/Bio'
import Gallery from './Pages/Gallery'
import Media from './Pages/Media'
import Social from './Pages/Social'
import Calendar from './Pages/Calendar'
import Contact from './Pages/Contact'
import { Switch, Route } from 'react-router-dom'
import { getContents } from './api/squidex'
import React, { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import CookieConsent from 'react-cookie-consent'

function App() {
  const [events, setEvents] = useState([])
  const [biografie, setBiografie] = useState([])
  const [eventsLoading, setEventsLoading] = useState(true)
  const [biografieLoading, setBiografieLoading] = useState(true)
  const [germanLanguage, toggleGermanLanguage] = useState(true)

  useEffect(() => {
    if (localStorage.getItem('i18nextLng') === 'de') {
      toggleGermanLanguage(true)
    } else {
      toggleGermanLanguage(false)
    }

    // Load each schema independently so one slow/error schema doesn't block others.
    setEventsLoading(true)
    getContents('event', { $top: 200 })
      .then((res) => setEvents(res.items || []))
      .catch(console.error)
      .finally(() => setEventsLoading(false))

    setBiografieLoading(true)
    getContents('biografie', { $top: 50 })
      .then((res) => setBiografie(res.items || []))
      .catch(console.error)
      .finally(() => setBiografieLoading(false))
  }, [])
  return (
    <div className='App'>
      <Switch>
        <Route exact path='/'>
          <Nav language={germanLanguage} onToggle={(lng) => toggleGermanLanguage(lng)} />
          <CookieConsent
            location='bottom'
            buttonText='Accept'
            cookieName='cookieSao'
            style={{ background: '#000001', marginLeft: '0px' }}
            buttonStyle={{
              color: '#000000',
              fontSize: '13px',
              background: '#FFFFFF',
              padding: '7px 45px',
              margin: '20px 25px',
            }}
            expires={150}
          >
            <p style={{ marginBottom: '-10px', marginLeft: '10px', fontSize: '13px' }}>
              We and some of our partners use cookies and similar technologies for the
              purposes described in the Cookie Policy.
              <br /> Cookies and similar technologies.
              <br />
              You consent to the use of such technologies by closing this notice.
            </p>
            <br />{' '}
            <span style={{ fontSize: '13px', color: '#000000', marginLeft: '10px' }}>
              <a href='/datenschutz' style={{ fontSize: '13x', color: '#FFFFFF' }}>
                Learn more
              </a>
            </span>
          </CookieConsent>
          <Hero language={germanLanguage} />
          <Bio biografie={biografie} language={germanLanguage} loading={biografieLoading} />
          <Media language={germanLanguage} />
          <Social />
          <Calendar language={germanLanguage} events={events} loading={eventsLoading} />
          <Gallery />
          <Contact />
          <FooterStart language={germanLanguage} />
        </Route>
        <Route exact path='/calendar'>
          <NavExtra language={germanLanguage} />
          <FooterStart language={germanLanguage} />
        </Route>
        <Route exact path='/imprint'>
          <NavExtra language={germanLanguage} />
          <Imprint language={germanLanguage} />
          <FooterStart language={germanLanguage} />
        </Route>
        <Route exact path='/datenschutz'>
          <NavExtra language={germanLanguage} />
          <Privacy language={germanLanguage} />
          <FooterStart language={germanLanguage} />
        </Route>
      </Switch>
    </div>
  )
}

export default withNamespaces()(App)
